import { defaultTheme } from "basis";
import { SIDEBAR_WIDTH } from "components/Sidebar/Sidebar";

export const theme = {
  ...defaultTheme,
  breakpoints: Object.keys(defaultTheme.breakpoints).reduce((acc, bp) => {
    acc[bp] = `${parseInt(defaultTheme.breakpoints[bp], 10) + SIDEBAR_WIDTH}px`;
    return acc;
  }, {}),
};
